<template>
  <div class="product-tabs-bar sticky top-64px h-64px bg-white w-full border-b border-gray-30">
    <div class="container mx-auto">
      <n-tabs v-model:value="activatedTab" size="large" justify-content="start" tab-style="padding: 20px 16px">
        <n-tab v-for="tab in tabs" :id="`${tab.id}-tab`" :key="tab.id" :name="tab.id" @click="handleClickTab(tab.id)">
          {{ tab.label }}
        </n-tab>
      </n-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NTabs, NTab } from 'naive-ui'

const activatedTab = defineModel<string>()

const emit = defineEmits<{
  (event: 'tab-change', value: string): void
}>()

const props = defineProps<{
  sections: {
    id: string
    show: boolean
    label?: string
  }[]
}>()

const tabs = computed(() => props.sections.filter(section => section.show && section.label).map(s => ({ ...s, label: s.label || '' })))

const handleClickTab = (id: string) => {
  emit('tab-change', id)
  scrollToId(id)
}
</script>

<style lang="scss" scoped>
.product-tabs-bar {
  :deep(.n-tabs) {
    .n-tabs-tab {
      @apply p-0;
    }
    .n-tabs-bar {
      @apply h-0.5;
    }

    .n-tabs-nav-scroll-wrapper {
      &.n-tabs-nav-scroll-wrapper--shadow-start::before {
        box-shadow: inset 20px 0 8px -8px rgba(white, 0.75);
      }
      &.n-tabs-nav-scroll-wrapper--shadow-end::after {
        box-shadow: inset -20px 0 8px -8px rgba(white, 0.75);
      }
    }
  }
}
</style>
